var mapJson ={
	"type": "FeatureCollection",
	"features": [{
		"type": "Feature",
		"properties": {
			"adcode": 150502,
			"name": "科尔沁区",
			"center": [122.264042, 43.617422],
			"centroid": [122.280573, 43.651865],
			"childrenNum": 0,
			"level": "district",
			"parent": {
				"adcode": 150500
			},
			"subFeatureIndex": 0,
			"acroutes": [100000, 150000, 150500]
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[121.808782, 43.793262],
						[121.808379, 43.784256],
						[121.813433, 43.775489],
						[121.798808, 43.775113],
						[121.797645, 43.771585],
						[121.785613, 43.773846],
						[121.773626, 43.759973],
						[121.805785, 43.741814],
						[121.813657, 43.725809],
						[121.804577, 43.719845],
						[121.814954, 43.712132],
						[121.83043, 43.70764],
						[121.84595, 43.699034],
						[121.844608, 43.690769],
						[121.852928, 43.692861],
						[121.858832, 43.673584],
						[121.869656, 43.673],
						[121.863796, 43.664492],
						[121.849439, 43.664526],
						[121.853107, 43.657011],
						[121.841612, 43.658796],
						[121.850512, 43.634942],
						[121.840091, 43.625261],
						[121.825689, 43.62763],
						[121.821619, 43.632402],
						[121.799076, 43.629999],
						[121.783555, 43.625913],
						[121.777249, 43.63786],
						[121.777786, 43.644519],
						[121.754349, 43.646064],
						[121.751083, 43.650869],
						[121.733953, 43.644451],
						[121.730554, 43.632642],
						[121.718522, 43.621965],
						[121.691775, 43.623716],
						[121.693206, 43.612831],
						[121.71311, 43.609019],
						[121.714317, 43.615784],
						[121.736234, 43.614926],
						[121.735071, 43.595074],
						[121.744374, 43.588684],
						[121.743301, 43.577518],
						[121.730375, 43.573566],
						[121.707966, 43.581985],
						[121.693877, 43.579236],
						[121.699513, 43.5669],
						[121.684216, 43.563291],
						[121.690478, 43.555007],
						[121.705819, 43.551192],
						[121.708279, 43.546723],
						[121.724828, 43.537955],
						[121.71302, 43.537612],
						[121.725991, 43.532282],
						[121.728228, 43.515705],
						[121.717627, 43.515533],
						[121.72134, 43.482331],
						[121.747058, 43.477203],
						[121.754125, 43.482744],
						[121.773537, 43.478339],
						[121.779083, 43.471558],
						[121.79107, 43.473245],
						[121.809005, 43.479612],
						[121.823139, 43.477031],
						[121.812807, 43.474691],
						[121.824526, 43.472419],
						[121.804085, 43.462436],
						[121.810616, 43.453347],
						[121.813389, 43.43785],
						[121.783645, 43.434854],
						[121.760342, 43.446632],
						[121.732924, 43.447286],
						[121.703896, 43.438952],
						[121.702509, 43.430652],
						[121.706669, 43.41608],
						[121.723844, 43.411015],
						[121.726304, 43.407087],
						[121.741109, 43.403572],
						[121.74348, 43.396714],
						[121.722771, 43.400919],
						[121.699781, 43.395956],
						[121.699155, 43.386271],
						[121.711813, 43.381238],
						[121.730554, 43.373377],
						[121.737397, 43.366723],
						[121.757301, 43.367413],
						[121.7607, 43.373446],
						[121.757122, 43.38041],
						[121.741199, 43.384478],
						[121.759984, 43.390441],
						[121.791964, 43.39151],
						[121.792009, 43.384409],
						[121.808245, 43.381583],
						[121.809497, 43.389924],
						[121.819829, 43.389407],
						[121.834768, 43.380859],
						[121.856282, 43.375653],
						[121.901949, 43.376722],
						[121.918364, 43.378376],
						[121.93791, 43.376308],
						[121.95343, 43.377411],
						[121.966401, 43.372757],
						[122.012336, 43.370688],
						[122.043332, 43.372757],
						[122.057556, 43.366309],
						[122.07397, 43.362999],
						[122.072986, 43.379652],
						[122.078354, 43.380135],
						[122.090072, 43.372067],
						[122.11843, 43.368999],
						[122.129164, 43.370723],
						[122.136544, 43.377997],
						[122.147458, 43.379514],
						[122.16016, 43.40719],
						[122.201533, 43.407363],
						[122.212223, 43.403159],
						[122.228638, 43.403193],
						[122.248676, 43.409189],
						[122.244784, 43.417286],
						[122.244963, 43.437644],
						[122.238925, 43.456962],
						[122.249749, 43.457478],
						[122.258158, 43.472557],
						[122.276764, 43.47858],
						[122.28401, 43.490212],
						[122.272381, 43.508516],
						[122.304674, 43.511681],
						[122.303511, 43.518354],
						[122.318987, 43.513435],
						[122.320821, 43.507277],
						[122.329364, 43.50769],
						[122.355037, 43.51739],
						[122.376238, 43.517597],
						[122.376328, 43.510752],
						[122.406653, 43.506039],
						[122.427496, 43.518388],
						[122.465559, 43.530391],
						[122.471597, 43.536408],
						[122.471955, 43.529084],
						[122.479111, 43.524682],
						[122.497584, 43.531904],
						[122.507916, 43.527536],
						[122.517979, 43.530734],
						[122.522273, 43.545622],
						[122.514133, 43.538368],
						[122.517622, 43.554285],
						[122.529385, 43.554904],
						[122.553806, 43.562019],
						[122.539404, 43.595555],
						[122.532292, 43.599505],
						[122.554343, 43.601429],
						[122.58024, 43.617467],
						[122.613785, 43.622652],
						[122.635657, 43.623373],
						[122.656903, 43.627596],
						[122.667816, 43.63326],
						[122.66956, 43.639165],
						[122.682442, 43.645652],
						[122.703822, 43.644039],
						[122.718045, 43.637174],
						[122.730077, 43.638306],
						[122.743316, 43.628797],
						[122.755035, 43.628969],
						[122.757137, 43.633501],
						[122.803564, 43.630514],
						[122.868732, 43.635217],
						[122.867971, 43.644725],
						[122.862425, 43.653305],
						[122.8673, 43.668506],
						[122.88291, 43.658967],
						[122.884163, 43.672829],
						[122.880674, 43.677563],
						[122.884878, 43.684561],
						[122.895568, 43.689328],
						[122.911178, 43.685178],
						[122.936315, 43.688711],
						[122.973841, 43.700885],
						[123.001348, 43.694884],
						[123.00278, 43.70812],
						[122.998978, 43.715011],
						[123.005642, 43.718165],
						[123.004121, 43.729134],
						[123.013469, 43.72694],
						[123.010204, 43.736743],
						[123.01906, 43.737428],
						[123.016153, 43.745618],
						[123.030108, 43.758945],
						[123.013872, 43.76035],
						[123.023265, 43.76953],
						[123.021744, 43.779428],
						[123.008952, 43.768674],
						[123.000722, 43.769564],
						[122.991956, 43.783469],
						[122.97733, 43.778537],
						[122.975585, 43.789393],
						[122.963867, 43.786893],
						[122.966998, 43.794802],
						[122.948883, 43.797849],
						[122.927995, 43.807708],
						[122.920705, 43.804799],
						[122.91006, 43.815649],
						[122.901338, 43.815923],
						[122.895165, 43.807092],
						[122.885817, 43.818113],
						[122.867479, 43.82328],
						[122.851109, 43.824444],
						[122.840687, 43.818353],
						[122.815685, 43.828071],
						[122.805979, 43.827455],
						[122.804995, 43.816778],
						[122.794663, 43.817428],
						[122.795781, 43.805244],
						[122.760804, 43.800725],
						[122.756063, 43.80942],
						[122.743137, 43.811097],
						[122.743316, 43.814485],
						[122.725291, 43.817805],
						[122.732313, 43.82109],
						[122.721176, 43.826463],
						[122.71147, 43.838815],
						[122.698589, 43.842646],
						[122.687362, 43.838438],
						[122.674525, 43.821672],
						[122.663478, 43.812363],
						[122.653459, 43.808085],
						[122.649657, 43.821741],
						[122.637759, 43.82595],
						[122.62121, 43.821022],
						[122.620405, 43.813835],
						[122.609581, 43.817873],
						[122.597952, 43.813903],
						[122.598041, 43.821638],
						[122.58346, 43.81979],
						[122.579166, 43.829508],
						[122.583102, 43.835907],
						[122.577422, 43.85024],
						[122.581805, 43.850651],
						[122.571786, 43.860398],
						[122.573128, 43.864947],
						[122.592495, 43.872025],
						[122.604929, 43.871307],
						[122.605556, 43.877222],
						[122.597281, 43.879342],
						[122.599428, 43.893904],
						[122.596073, 43.897937],
						[122.607255, 43.898689],
						[122.624162, 43.911094],
						[122.633152, 43.929031],
						[122.642143, 43.933847],
						[122.634897, 43.93617],
						[122.651848, 43.949421],
						[122.664462, 43.961952],
						[122.644692, 43.961303],
						[122.637178, 43.966629],
						[122.59992, 43.952631],
						[122.54419, 43.937741],
						[122.533142, 43.942693],
						[122.525986, 43.950035],
						[122.508631, 43.956045],
						[122.488996, 43.948123],
						[122.465246, 43.947987],
						[122.465156, 43.944332],
						[122.436844, 43.939722],
						[122.40379, 43.918304],
						[122.394711, 43.904465],
						[122.356156, 43.900911],
						[122.348955, 43.898587],
						[122.36036, 43.873222],
						[122.347747, 43.876948],
						[122.346897, 43.872777],
						[122.326636, 43.870007],
						[122.315051, 43.87688],
						[122.315812, 43.869324],
						[122.296489, 43.867853],
						[122.282803, 43.863271],
						[122.272515, 43.870349],
						[122.265404, 43.867853],
						[122.264107, 43.853524],
						[122.256414, 43.837617],
						[122.235481, 43.830877],
						[122.228996, 43.834435],
						[122.212536, 43.832622],
						[122.209897, 43.838233],
						[122.188517, 43.835599],
						[122.188696, 43.823794],
						[122.195048, 43.818421],
						[122.180914, 43.804901],
						[122.179661, 43.788331],
						[122.162397, 43.780626],
						[122.162218, 43.77114],
						[122.168524, 43.749935],
						[122.146966, 43.745412],
						[122.152199, 43.732116],
						[122.138512, 43.731019],
						[122.134039, 43.719708],
						[122.121516, 43.715148],
						[122.128225, 43.712611],
						[122.129656, 43.70356],
						[122.057869, 43.696667],
						[122.051383, 43.728997],
						[122.048789, 43.734344],
						[122.048699, 43.754355],
						[122.044942, 43.759082],
						[122.028438, 43.760213],
						[122.015601, 43.756787],
						[122.010279, 43.764221],
						[121.983755, 43.75271],
						[121.942696, 43.759185],
						[121.92807, 43.771414],
						[121.916351, 43.789666],
						[121.893451, 43.795384],
						[121.883611, 43.801444],
						[121.87632, 43.796959],
						[121.838212, 43.802642],
						[121.818801, 43.798671],
						[121.808782, 43.793262]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": 150521,
			"name": "科尔沁左翼中旗",
			"center": [123.313873, 44.127166],
			"centroid": [122.492569, 44.049623],
			"childrenNum": 0,
			"level": "district",
			"parent": {
				"adcode": 150500
			},
			"subFeatureIndex": 1,
			"acroutes": [100000, 150000, 150500]
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[123.001348, 43.694884],
						[122.995802, 43.684012],
						[123.009444, 43.680959],
						[123.017629, 43.675368],
						[123.031316, 43.67403],
						[123.040127, 43.66758],
						[123.049609, 43.670427],
						[123.052293, 43.666036],
						[123.073583, 43.674167],
						[123.085794, 43.670771],
						[123.094292, 43.659516],
						[123.083557, 43.640812],
						[123.085391, 43.633089],
						[123.122873, 43.628214],
						[123.128464, 43.624952],
						[123.155568, 43.630789],
						[123.195644, 43.60634],
						[123.207363, 43.602013],
						[123.204276, 43.597307],
						[123.220289, 43.588925],
						[123.229816, 43.595314],
						[123.26931, 43.584149],
						[123.298651, 43.578652],
						[123.294492, 43.574769],
						[123.304511, 43.55071],
						[123.346331, 43.561504],
						[123.356707, 43.567724],
						[123.403179, 43.558823],
						[123.452648, 43.54576],
						[123.455958, 43.548029],
						[123.460922, 43.568583],
						[123.446654, 43.58092],
						[123.433952, 43.575559],
						[123.42116, 43.598269],
						[123.426214, 43.610805],
						[123.434131, 43.600673],
						[123.458507, 43.593975],
						[123.468079, 43.585661],
						[123.474475, 43.590436],
						[123.496973, 43.58999],
						[123.510391, 43.592257],
						[123.513656, 43.605585],
						[123.507036, 43.61156],
						[123.513119, 43.614994],
						[123.511598, 43.626051],
						[123.526001, 43.629587],
						[123.529042, 43.625639],
						[123.537138, 43.633878],
						[123.53347, 43.637448],
						[123.537183, 43.649702],
						[123.529624, 43.659105],
						[123.527387, 43.669295],
						[123.51871, 43.681817],
						[123.52533, 43.695056],
						[123.516429, 43.70596],
						[123.51701, 43.71388],
						[123.509273, 43.71676],
						[123.49733, 43.731328],
						[123.491918, 43.729168],
						[123.48266, 43.737771],
						[123.485522, 43.745549],
						[123.485522, 43.76333],
						[123.490085, 43.770147],
						[123.49827, 43.77114],
						[123.496883, 43.785592],
						[123.492455, 43.792714],
						[123.482302, 43.794768],
						[123.474251, 43.805586],
						[123.473938, 43.816025],
						[123.467095, 43.816025],
						[123.462085, 43.82263],
						[123.462711, 43.836249],
						[123.466513, 43.839088],
						[123.468258, 43.853079],
						[123.461951, 43.85903],
						[123.463651, 43.864639],
						[123.453184, 43.878213],
						[123.444015, 43.877256],
						[123.43838, 43.895066],
						[123.440035, 43.898074],
						[123.427958, 43.918099],
						[123.428316, 43.927391],
						[123.415121, 43.928792],
						[123.412393, 43.938082],
						[123.404521, 43.939141],
						[123.397052, 43.954782],
						[123.382515, 43.952084],
						[123.370707, 43.969906],
						[123.381442, 43.974822],
						[123.400943, 43.979293],
						[123.370081, 44.004442],
						[123.365742, 44.01396],
						[123.332376, 44.028353],
						[123.326248, 44.045709],
						[123.320791, 44.05205],
						[123.331168, 44.055697],
						[123.332823, 44.066945],
						[123.328395, 44.083846],
						[123.350669, 44.092636],
						[123.348478, 44.09703],
						[123.354247, 44.106703],
						[123.362433, 44.133603],
						[123.384483, 44.141772],
						[123.382292, 44.150928],
						[123.386406, 44.161851],
						[123.323654, 44.17978],
						[123.316721, 44.189882],
						[123.299769, 44.195221],
						[123.293105, 44.21416],
						[123.286754, 44.214874],
						[123.277093, 44.252562],
						[123.240864, 44.295082],
						[123.196986, 44.345033],
						[123.173728, 44.345237],
						[123.169523, 44.350426],
						[123.148725, 44.361618],
						[123.123454, 44.364297],
						[123.127256, 44.368773],
						[123.114509, 44.402466],
						[123.136157, 44.406024],
						[123.142105, 44.428146],
						[123.12408, 44.45798],
						[123.137096, 44.461839],
						[123.125914, 44.477003],
						[123.137677, 44.489253],
						[123.136157, 44.502414],
						[123.124885, 44.509585],
						[123.111557, 44.509721],
						[123.083557, 44.506338],
						[123.067142, 44.506135],
						[123.040216, 44.499065],
						[123.024875, 44.492975],
						[122.950806, 44.449177],
						[122.940877, 44.445418],
						[122.925356, 44.434345],
						[122.899236, 44.419847],
						[122.856118, 44.398298],
						[122.77704, 44.375926],
						[122.760625, 44.369722],
						[122.726677, 44.34198],
						[122.703106, 44.318943],
						[122.692103, 44.303976],
						[122.690046, 44.296881],
						[122.675554, 44.285779],
						[122.642813, 44.283606],
						[122.597326, 44.272501],
						[122.577825, 44.265233],
						[122.555237, 44.259255],
						[122.51288, 44.250218],
						[122.482689, 44.236932],
						[122.372749, 44.236117],
						[122.319434, 44.232922],
						[122.31201, 44.234622],
						[122.271397, 44.255654],
						[122.258874, 44.256809],
						[122.226312, 44.263739],
						[122.163917, 44.255416],
						[122.139272, 44.26666],
						[122.105682, 44.272298],
						[122.093516, 44.281161],
						[122.019135, 44.303942],
						[122.002541, 44.313038],
						[121.983174, 44.33031],
						[121.965641, 44.336926],
						[121.934376, 44.343507],
						[121.922747, 44.350019],
						[121.910268, 44.345678],
						[121.90253, 44.350766],
						[121.892422, 44.341913],
						[121.882, 44.344626],
						[121.873905, 44.332685],
						[121.865809, 44.32634],
						[121.85248, 44.327562],
						[121.842327, 44.321352],
						[121.828015, 44.324135],
						[121.81652, 44.321658],
						[121.763562, 44.305367],
						[121.748355, 44.294844],
						[121.720982, 44.288631],
						[121.707787, 44.283742],
						[121.652236, 44.282655],
						[121.626831, 44.281229],
						[121.579867, 44.293079],
						[121.53666, 44.327324],
						[121.525389, 44.341098],
						[121.53344, 44.346492],
						[121.514878, 44.356565],
						[121.508885, 44.351715],
						[121.430835, 44.414291],
						[121.416254, 44.401924],
						[121.427883, 44.395925],
						[121.421174, 44.388028],
						[121.395366, 44.368196],
						[121.370006, 44.344898],
						[121.349655, 44.333805],
						[121.336639, 44.331464],
						[121.336818, 44.319452],
						[121.287126, 44.298918],
						[121.226878, 44.287443],
						[121.208451, 44.292603],
						[121.195972, 44.277935],
						[121.165915, 44.268018],
						[121.169001, 44.244136],
						[121.167972, 44.213684],
						[121.183985, 44.182229],
						[121.204783, 44.175086],
						[121.196464, 44.16641],
						[121.222495, 44.142045],
						[121.224508, 44.135135],
						[121.202368, 44.127237],
						[121.227013, 44.131356],
						[121.239805, 44.139117],
						[121.241817, 44.133875],
						[121.266775, 44.138879],
						[121.268028, 44.141466],
						[121.291107, 44.129313],
						[121.34138, 44.127849],
						[121.381546, 44.142045],
						[121.394651, 44.137313],
						[121.402881, 44.108134],
						[121.425557, 44.108781],
						[121.469524, 44.08354],
						[121.531919, 44.03357],
						[121.560634, 44.000757],
						[121.560232, 43.984071],
						[121.571682, 43.978474],
						[121.583713, 43.97919],
						[121.579285, 43.968643],
						[121.585816, 43.963317],
						[121.589528, 43.96697],
						[121.597176, 43.957445],
						[121.609476, 43.95304],
						[121.604691, 43.950377],
						[121.634926, 43.928518],
						[121.644632, 43.929782],
						[121.65975, 43.918474],
						[121.666772, 43.90983],
						[121.678044, 43.908668],
						[121.684484, 43.894178],
						[121.668114, 43.880265],
						[121.669858, 43.869905],
						[121.68842, 43.854652],
						[121.687526, 43.846238],
						[121.695398, 43.82944],
						[121.700497, 43.82725],
						[121.804667, 43.800759],
						[121.808782, 43.793262],
						[121.818801, 43.798671],
						[121.838212, 43.802642],
						[121.87632, 43.796959],
						[121.883611, 43.801444],
						[121.893451, 43.795384],
						[121.916351, 43.789666],
						[121.92807, 43.771414],
						[121.942696, 43.759185],
						[121.983755, 43.75271],
						[122.010279, 43.764221],
						[122.015601, 43.756787],
						[122.028438, 43.760213],
						[122.044942, 43.759082],
						[122.048699, 43.754355],
						[122.048789, 43.734344],
						[122.051383, 43.728997],
						[122.057869, 43.696667],
						[122.129656, 43.70356],
						[122.128225, 43.712611],
						[122.121516, 43.715148],
						[122.134039, 43.719708],
						[122.138512, 43.731019],
						[122.152199, 43.732116],
						[122.146966, 43.745412],
						[122.168524, 43.749935],
						[122.162218, 43.77114],
						[122.162397, 43.780626],
						[122.179661, 43.788331],
						[122.180914, 43.804901],
						[122.195048, 43.818421],
						[122.188696, 43.823794],
						[122.188517, 43.835599],
						[122.209897, 43.838233],
						[122.212536, 43.832622],
						[122.228996, 43.834435],
						[122.235481, 43.830877],
						[122.256414, 43.837617],
						[122.264107, 43.853524],
						[122.265404, 43.867853],
						[122.272515, 43.870349],
						[122.282803, 43.863271],
						[122.296489, 43.867853],
						[122.315812, 43.869324],
						[122.315051, 43.87688],
						[122.326636, 43.870007],
						[122.346897, 43.872777],
						[122.347747, 43.876948],
						[122.36036, 43.873222],
						[122.348955, 43.898587],
						[122.356156, 43.900911],
						[122.394711, 43.904465],
						[122.40379, 43.918304],
						[122.436844, 43.939722],
						[122.465156, 43.944332],
						[122.465246, 43.947987],
						[122.488996, 43.948123],
						[122.508631, 43.956045],
						[122.525986, 43.950035],
						[122.533142, 43.942693],
						[122.54419, 43.937741],
						[122.59992, 43.952631],
						[122.637178, 43.966629],
						[122.644692, 43.961303],
						[122.664462, 43.961952],
						[122.651848, 43.949421],
						[122.634897, 43.93617],
						[122.642143, 43.933847],
						[122.633152, 43.929031],
						[122.624162, 43.911094],
						[122.607255, 43.898689],
						[122.596073, 43.897937],
						[122.599428, 43.893904],
						[122.597281, 43.879342],
						[122.605556, 43.877222],
						[122.604929, 43.871307],
						[122.592495, 43.872025],
						[122.573128, 43.864947],
						[122.571786, 43.860398],
						[122.581805, 43.850651],
						[122.577422, 43.85024],
						[122.583102, 43.835907],
						[122.579166, 43.829508],
						[122.58346, 43.81979],
						[122.598041, 43.821638],
						[122.597952, 43.813903],
						[122.609581, 43.817873],
						[122.620405, 43.813835],
						[122.62121, 43.821022],
						[122.637759, 43.82595],
						[122.649657, 43.821741],
						[122.653459, 43.808085],
						[122.663478, 43.812363],
						[122.674525, 43.821672],
						[122.687362, 43.838438],
						[122.698589, 43.842646],
						[122.71147, 43.838815],
						[122.721176, 43.826463],
						[122.732313, 43.82109],
						[122.725291, 43.817805],
						[122.743316, 43.814485],
						[122.743137, 43.811097],
						[122.756063, 43.80942],
						[122.760804, 43.800725],
						[122.795781, 43.805244],
						[122.794663, 43.817428],
						[122.804995, 43.816778],
						[122.805979, 43.827455],
						[122.815685, 43.828071],
						[122.840687, 43.818353],
						[122.851109, 43.824444],
						[122.867479, 43.82328],
						[122.885817, 43.818113],
						[122.895165, 43.807092],
						[122.901338, 43.815923],
						[122.91006, 43.815649],
						[122.920705, 43.804799],
						[122.927995, 43.807708],
						[122.948883, 43.797849],
						[122.966998, 43.794802],
						[122.963867, 43.786893],
						[122.975585, 43.789393],
						[122.97733, 43.778537],
						[122.991956, 43.783469],
						[123.000722, 43.769564],
						[123.008952, 43.768674],
						[123.021744, 43.779428],
						[123.023265, 43.76953],
						[123.013872, 43.76035],
						[123.030108, 43.758945],
						[123.016153, 43.745618],
						[123.01906, 43.737428],
						[123.010204, 43.736743],
						[123.013469, 43.72694],
						[123.004121, 43.729134],
						[123.005642, 43.718165],
						[122.998978, 43.715011],
						[123.00278, 43.70812],
						[123.001348, 43.694884]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": 150522,
			"name": "科尔沁左翼后旗",
			"center": [122.355155, 42.954564],
			"centroid": [122.688034, 43.186904],
			"childrenNum": 0,
			"level": "district",
			"parent": {
				"adcode": 150500
			},
			"subFeatureIndex": 2,
			"acroutes": [100000, 150000, 150500]
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[122.206095, 42.732472],
						[122.226088, 42.728082],
						[122.241832, 42.712506],
						[122.257442, 42.704245],
						[122.259187, 42.696925],
						[122.295863, 42.693683],
						[122.307805, 42.690476],
						[122.311786, 42.682108],
						[122.324489, 42.684828],
						[122.334105, 42.680365],
						[122.334865, 42.672798],
						[122.341172, 42.671298],
						[122.360584, 42.683433],
						[122.395963, 42.6842],
						[122.396455, 42.707452],
						[122.401107, 42.713377],
						[122.425215, 42.723169],
						[122.434071, 42.728848],
						[122.443598, 42.74867],
						[122.461131, 42.756158],
						[122.45724, 42.77423],
						[122.437828, 42.770087],
						[122.373331, 42.775449],
						[122.361657, 42.78819],
						[122.355977, 42.812412],
						[122.35052, 42.820171],
						[122.352309, 42.831546],
						[122.359376, 42.836103],
						[122.399318, 42.839163],
						[122.430627, 42.843337],
						[122.48667, 42.836868],
						[122.505277, 42.836624],
						[122.522407, 42.831059],
						[122.562796, 42.826224],
						[122.57608, 42.81871],
						[122.569774, 42.809141],
						[122.580956, 42.789722],
						[122.617856, 42.778548],
						[122.625057, 42.773221],
						[122.653414, 42.782307],
						[122.67864, 42.781089],
						[122.701004, 42.782203],
						[122.717329, 42.785962],
						[122.733029, 42.785823],
						[122.73777, 42.771201],
						[122.756376, 42.768242],
						[122.765769, 42.759258],
						[122.78451, 42.757482],
						[122.794663, 42.74766],
						[122.798733, 42.738743],
						[122.804414, 42.74139],
						[122.818279, 42.73613],
						[122.818592, 42.732123],
						[122.831742, 42.722333],
						[122.846547, 42.720137],
						[122.846413, 42.708532],
						[122.855224, 42.706999],
						[122.850885, 42.714422],
						[122.858534, 42.726131],
						[122.875441, 42.739892],
						[122.883581, 42.751979],
						[122.877856, 42.751143],
						[122.878795, 42.759606],
						[122.887293, 42.770122],
						[122.928845, 42.772141],
						[122.945976, 42.753686],
						[122.961899, 42.756541],
						[122.974109, 42.763228],
						[122.969145, 42.767023],
						[122.979924, 42.777364],
						[122.987036, 42.778304],
						[123.007744, 42.77329],
						[123.013112, 42.774962],
						[123.032434, 42.76765],
						[123.047954, 42.771515],
						[123.058465, 42.769077],
						[123.083468, 42.788712],
						[123.08718, 42.786415],
						[123.116029, 42.800441],
						[123.132355, 42.802704],
						[123.167779, 42.811577],
						[123.187638, 42.825528],
						[123.221631, 42.825319],
						[123.227579, 42.832172],
						[123.189427, 42.848171],
						[123.182315, 42.846014],
						[123.170686, 42.852135],
						[123.170015, 42.859749],
						[123.179408, 42.878765],
						[123.18728, 42.887071],
						[123.188756, 42.895828],
						[123.184104, 42.925912],
						[123.206245, 42.951677],
						[123.219305, 42.953517],
						[123.233618, 42.965701],
						[123.234602, 42.971878],
						[123.258978, 42.99301],
						[123.272307, 42.996722],
						[123.321954, 43.000781],
						[123.332734, 43.005221],
						[123.351117, 43.007302],
						[123.383812, 43.014828],
						[123.402911, 43.020585],
						[123.411275, 43.028248],
						[123.435383, 43.027901],
						[123.448488, 43.038129],
						[123.471881, 43.042705],
						[123.489995, 43.032166],
						[123.493797, 43.025751],
						[123.522378, 43.020342],
						[123.536601, 43.007198],
						[123.557533, 43.010181],
						[123.572696, 43.004215],
						[123.571846, 43.009834],
						[123.582357, 43.009973],
						[123.588172, 43.016389],
						[123.580881, 43.020654],
						[123.582715, 43.03702],
						[123.588574, 43.032166],
						[123.596715, 43.041492],
						[123.608702, 43.046206],
						[123.607941, 43.053762],
						[123.596312, 43.058649],
						[123.60575, 43.064574],
						[123.617021, 43.077776],
						[123.625743, 43.079127],
						[123.631199, 43.088826],
						[123.627442, 43.099806],
						[123.633436, 43.112168],
						[123.629679, 43.119301],
						[123.639161, 43.125705],
						[123.636254, 43.141455],
						[123.643365, 43.143877],
						[123.653653, 43.159587],
						[123.647436, 43.171972],
						[123.659914, 43.175016],
						[123.667965, 43.180931],
						[123.665416, 43.193381],
						[123.655844, 43.19421],
						[123.648106, 43.203892],
						[123.64663, 43.213814],
						[123.657902, 43.221591],
						[123.670068, 43.221245],
						[123.677045, 43.224702],
						[123.667965, 43.235899],
						[123.676329, 43.242844],
						[123.665192, 43.258459],
						[123.666937, 43.268199],
						[123.680668, 43.271998],
						[123.686438, 43.277386],
						[123.698559, 43.27224],
						[123.705492, 43.278111],
						[123.696367, 43.281322],
						[123.696054, 43.294925],
						[123.703926, 43.298136],
						[123.70008, 43.311148],
						[123.715913, 43.31139],
						[123.719715, 43.31912],
						[123.709159, 43.319741],
						[123.702584, 43.326781],
						[123.714169, 43.331818],
						[123.704463, 43.337165],
						[123.705671, 43.344789],
						[123.713051, 43.346548],
						[123.711396, 43.354481],
						[123.720431, 43.357654],
						[123.696144, 43.356171],
						[123.704329, 43.362999],
						[123.703747, 43.370688],
						[123.608567, 43.366275],
						[123.584057, 43.377273],
						[123.555387, 43.406949],
						[123.545099, 43.415081],
						[123.532441, 43.401504],
						[123.525196, 43.398575],
						[123.519649, 43.402469],
						[123.500685, 43.426105],
						[123.486998, 43.445496],
						[123.442003, 43.437644],
						[123.442674, 43.420559],
						[123.419863, 43.410085],
						[123.413959, 43.425898],
						[123.395486, 43.441776],
						[123.389493, 43.449387],
						[123.389493, 43.457788],
						[123.375851, 43.476549],
						[123.36449, 43.483364],
						[123.335372, 43.480851],
						[123.31605, 43.492001],
						[123.325443, 43.506211],
						[123.329871, 43.519041],
						[123.306166, 43.535411],
						[123.304511, 43.55071],
						[123.294492, 43.574769],
						[123.298651, 43.578652],
						[123.26931, 43.584149],
						[123.229816, 43.595314],
						[123.220289, 43.588925],
						[123.204276, 43.597307],
						[123.207363, 43.602013],
						[123.195644, 43.60634],
						[123.155568, 43.630789],
						[123.128464, 43.624952],
						[123.122873, 43.628214],
						[123.085391, 43.633089],
						[123.083557, 43.640812],
						[123.094292, 43.659516],
						[123.085794, 43.670771],
						[123.073583, 43.674167],
						[123.052293, 43.666036],
						[123.049609, 43.670427],
						[123.040127, 43.66758],
						[123.031316, 43.67403],
						[123.017629, 43.675368],
						[123.009444, 43.680959],
						[122.995802, 43.684012],
						[123.001348, 43.694884],
						[122.973841, 43.700885],
						[122.936315, 43.688711],
						[122.911178, 43.685178],
						[122.895568, 43.689328],
						[122.884878, 43.684561],
						[122.880674, 43.677563],
						[122.884163, 43.672829],
						[122.88291, 43.658967],
						[122.8673, 43.668506],
						[122.862425, 43.653305],
						[122.867971, 43.644725],
						[122.868732, 43.635217],
						[122.803564, 43.630514],
						[122.757137, 43.633501],
						[122.755035, 43.628969],
						[122.743316, 43.628797],
						[122.730077, 43.638306],
						[122.718045, 43.637174],
						[122.703822, 43.644039],
						[122.682442, 43.645652],
						[122.66956, 43.639165],
						[122.667816, 43.63326],
						[122.656903, 43.627596],
						[122.635657, 43.623373],
						[122.613785, 43.622652],
						[122.58024, 43.617467],
						[122.554343, 43.601429],
						[122.532292, 43.599505],
						[122.539404, 43.595555],
						[122.553806, 43.562019],
						[122.529385, 43.554904],
						[122.517622, 43.554285],
						[122.514133, 43.538368],
						[122.522273, 43.545622],
						[122.517979, 43.530734],
						[122.507916, 43.527536],
						[122.497584, 43.531904],
						[122.479111, 43.524682],
						[122.471955, 43.529084],
						[122.471597, 43.536408],
						[122.465559, 43.530391],
						[122.427496, 43.518388],
						[122.406653, 43.506039],
						[122.376328, 43.510752],
						[122.376238, 43.517597],
						[122.355037, 43.51739],
						[122.329364, 43.50769],
						[122.320821, 43.507277],
						[122.318987, 43.513435],
						[122.303511, 43.518354],
						[122.304674, 43.511681],
						[122.272381, 43.508516],
						[122.28401, 43.490212],
						[122.276764, 43.47858],
						[122.258158, 43.472557],
						[122.249749, 43.457478],
						[122.238925, 43.456962],
						[122.244963, 43.437644],
						[122.244784, 43.417286],
						[122.248676, 43.409189],
						[122.228638, 43.403193],
						[122.212223, 43.403159],
						[122.201533, 43.407363],
						[122.16016, 43.40719],
						[122.147458, 43.379514],
						[122.136544, 43.377997],
						[122.129164, 43.370723],
						[122.11843, 43.368999],
						[122.090072, 43.372067],
						[122.078354, 43.380135],
						[122.072986, 43.379652],
						[122.07397, 43.362999],
						[122.057556, 43.366309],
						[122.043332, 43.372757],
						[122.012336, 43.370688],
						[121.966401, 43.372757],
						[121.95343, 43.377411],
						[121.93791, 43.376308],
						[121.918364, 43.378376],
						[121.901949, 43.376722],
						[121.856282, 43.375653],
						[121.834768, 43.380859],
						[121.819829, 43.389407],
						[121.809497, 43.389924],
						[121.808245, 43.381583],
						[121.792009, 43.384409],
						[121.791964, 43.39151],
						[121.759984, 43.390441],
						[121.741199, 43.384478],
						[121.757122, 43.38041],
						[121.7607, 43.373446],
						[121.757301, 43.367413],
						[121.737397, 43.366723],
						[121.730554, 43.373377],
						[121.711813, 43.381238],
						[121.690478, 43.377997],
						[121.667443, 43.377825],
						[121.636358, 43.372826],
						[121.643648, 43.370447],
						[121.642843, 43.361861],
						[121.630767, 43.35955],
						[121.625668, 43.363826],
						[121.604199, 43.363206],
						[121.595432, 43.35586],
						[121.591049, 43.343513],
						[121.593151, 43.332163],
						[121.605317, 43.323503],
						[121.604333, 43.311079],
						[121.594493, 43.314565],
						[121.595298, 43.309423],
						[121.605093, 43.30787],
						[121.603036, 43.302899],
						[121.590333, 43.305005],
						[121.606793, 43.297342],
						[121.618511, 43.282254],
						[121.658095, 43.256248],
						[121.673973, 43.25155],
						[121.669903, 43.244813],
						[121.680996, 43.239458],
						[121.696024, 43.226326],
						[121.703583, 43.216683],
						[121.735608, 43.207557],
						[121.761147, 43.192274],
						[121.76155, 43.173563],
						[121.77139, 43.151352],
						[121.770137, 43.141662],
						[121.761371, 43.12574],
						[121.76647, 43.113103],
						[121.781319, 43.101711],
						[121.781677, 43.092429],
						[121.78946, 43.072301],
						[121.806858, 43.048008],
						[121.807306, 43.035147],
						[121.821127, 43.014342],
						[121.818309, 43.00588],
						[121.818443, 42.99013],
						[121.831906, 42.95855],
						[121.8451, 42.954315],
						[121.852704, 42.940983],
						[121.862902, 42.931469],
						[121.872026, 42.9281],
						[121.884282, 42.918722],
						[121.887726, 42.904931],
						[121.916843, 42.900692],
						[121.927354, 42.881024],
						[121.969219, 42.884082],
						[121.989615, 42.881788],
						[122.008713, 42.862287],
						[122.012202, 42.855438],
						[122.029109, 42.853247],
						[122.018956, 42.847058],
						[122.026112, 42.825146],
						[122.023294, 42.807297],
						[122.029646, 42.794908],
						[122.043958, 42.796439],
						[122.057913, 42.778478],
						[122.122634, 42.778896],
						[122.13319, 42.786311],
						[122.137841, 42.777016],
						[122.174607, 42.751561],
						[122.206095, 42.732472]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": 150523,
			"name": "开鲁县",
			"center": [121.308797, 43.602432],
			"centroid": [121.317588, 43.728444],
			"childrenNum": 0,
			"level": "district",
			"parent": {
				"adcode": 150500
			},
			"subFeatureIndex": 3,
			"acroutes": [100000, 150000, 150500]
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[120.797987, 43.849693],
						[120.798479, 43.841346],
						[120.786582, 43.834675],
						[120.78694, 43.814348],
						[120.836274, 43.788776],
						[120.870088, 43.754937],
						[120.876216, 43.739553],
						[120.904349, 43.721319],
						[120.921748, 43.704383],
						[120.939997, 43.698073],
						[120.958246, 43.670359],
						[120.968086, 43.658315],
						[120.984545, 43.660168],
						[120.984545, 43.650937],
						[120.973363, 43.64524],
						[120.96245, 43.633707],
						[120.95261, 43.633604],
						[120.943843, 43.625879],
						[120.943664, 43.617776],
						[120.933959, 43.611629],
						[120.915576, 43.60816],
						[120.899474, 43.60136],
						[120.882209, 43.598509],
						[120.863737, 43.59291],
						[120.820485, 43.56958],
						[120.802192, 43.558513],
						[120.787745, 43.561401],
						[120.774997, 43.55597],
						[120.762027, 43.55487],
						[120.753618, 43.545863],
						[120.738276, 43.540947],
						[120.711082, 43.517906],
						[120.700437, 43.517562],
						[120.684916, 43.504628],
						[120.680623, 43.482607],
						[120.681964, 43.474209],
						[120.66877, 43.460784],
						[120.656425, 43.452142],
						[120.641576, 43.44918],
						[120.605883, 43.426002],
						[120.571801, 43.430032],
						[120.54246, 43.42862],
						[120.51531, 43.414736],
						[120.492454, 43.414461],
						[120.48002, 43.41229],
						[120.454705, 43.395232],
						[120.43167, 43.387201],
						[120.422188, 43.379755],
						[120.462979, 43.379618],
						[120.483867, 43.383444],
						[120.51048, 43.380721],
						[120.543265, 43.387443],
						[120.554536, 43.38372],
						[120.57113, 43.385926],
						[120.597161, 43.396507],
						[120.62042, 43.398334],
						[120.637237, 43.402194],
						[120.65969, 43.400608],
						[120.668412, 43.402366],
						[120.685364, 43.411256],
						[120.702852, 43.413082],
						[120.719714, 43.421041],
						[120.734877, 43.421075],
						[120.74512, 43.429653],
						[120.756346, 43.423349],
						[120.773343, 43.43389],
						[120.78524, 43.436645],
						[120.790563, 43.441019],
						[120.786582, 43.448216],
						[120.790428, 43.457616],
						[120.799642, 43.457995],
						[120.837303, 43.472316],
						[120.846651, 43.477892],
						[120.880152, 43.475689],
						[120.895359, 43.47827],
						[120.928368, 43.495408],
						[120.943978, 43.506521],
						[120.960303, 43.513228],
						[120.97153, 43.514192],
						[120.988615, 43.511646],
						[121.006059, 43.512988],
						[121.030033, 43.519213],
						[121.04533, 43.532591],
						[121.090773, 43.523031],
						[121.098108, 43.528293],
						[121.11099, 43.528568],
						[121.12575, 43.522825],
						[121.141091, 43.525817],
						[121.154062, 43.532076],
						[121.174503, 43.536821],
						[121.194764, 43.537715],
						[121.219319, 43.531663],
						[121.230412, 43.535342],
						[121.244993, 43.534998],
						[121.267088, 43.529634],
						[121.280998, 43.529565],
						[121.301036, 43.532798],
						[121.314455, 43.538987],
						[121.329349, 43.535824],
						[121.348537, 43.538918],
						[121.372153, 43.538368],
						[121.38906, 43.529428],
						[121.399839, 43.526505],
						[121.406504, 43.501945],
						[121.41035, 43.496887],
						[121.417998, 43.470078],
						[121.41196, 43.467324],
						[121.423053, 43.455998],
						[121.439512, 43.454724],
						[121.469703, 43.443051],
						[121.498821, 43.436817],
						[121.499894, 43.424865],
						[121.510182, 43.410912],
						[121.525881, 43.402056],
						[121.528296, 43.367309],
						[121.533798, 43.370447],
						[121.548334, 43.365447],
						[121.559427, 43.354619],
						[121.566449, 43.339718],
						[121.560545, 43.334578],
						[121.56618, 43.322329],
						[121.579375, 43.317429],
						[121.593106, 43.318879],
						[121.604333, 43.311079],
						[121.605317, 43.323503],
						[121.593151, 43.332163],
						[121.591049, 43.343513],
						[121.595432, 43.35586],
						[121.604199, 43.363206],
						[121.625668, 43.363826],
						[121.630767, 43.35955],
						[121.642843, 43.361861],
						[121.643648, 43.370447],
						[121.636358, 43.372826],
						[121.667443, 43.377825],
						[121.690478, 43.377997],
						[121.711813, 43.381238],
						[121.699155, 43.386271],
						[121.699781, 43.395956],
						[121.722771, 43.400919],
						[121.74348, 43.396714],
						[121.741109, 43.403572],
						[121.726304, 43.407087],
						[121.723844, 43.411015],
						[121.706669, 43.41608],
						[121.702509, 43.430652],
						[121.703896, 43.438952],
						[121.732924, 43.447286],
						[121.760342, 43.446632],
						[121.783645, 43.434854],
						[121.813389, 43.43785],
						[121.810616, 43.453347],
						[121.804085, 43.462436],
						[121.824526, 43.472419],
						[121.812807, 43.474691],
						[121.823139, 43.477031],
						[121.809005, 43.479612],
						[121.79107, 43.473245],
						[121.779083, 43.471558],
						[121.773537, 43.478339],
						[121.754125, 43.482744],
						[121.747058, 43.477203],
						[121.72134, 43.482331],
						[121.717627, 43.515533],
						[121.728228, 43.515705],
						[121.725991, 43.532282],
						[121.71302, 43.537612],
						[121.724828, 43.537955],
						[121.708279, 43.546723],
						[121.705819, 43.551192],
						[121.690478, 43.555007],
						[121.684216, 43.563291],
						[121.699513, 43.5669],
						[121.693877, 43.579236],
						[121.707966, 43.581985],
						[121.730375, 43.573566],
						[121.743301, 43.577518],
						[121.744374, 43.588684],
						[121.735071, 43.595074],
						[121.736234, 43.614926],
						[121.714317, 43.615784],
						[121.71311, 43.609019],
						[121.693206, 43.612831],
						[121.691775, 43.623716],
						[121.718522, 43.621965],
						[121.730554, 43.632642],
						[121.733953, 43.644451],
						[121.751083, 43.650869],
						[121.754349, 43.646064],
						[121.777786, 43.644519],
						[121.777249, 43.63786],
						[121.783555, 43.625913],
						[121.799076, 43.629999],
						[121.821619, 43.632402],
						[121.825689, 43.62763],
						[121.840091, 43.625261],
						[121.850512, 43.634942],
						[121.841612, 43.658796],
						[121.853107, 43.657011],
						[121.849439, 43.664526],
						[121.863796, 43.664492],
						[121.869656, 43.673],
						[121.858832, 43.673584],
						[121.852928, 43.692861],
						[121.844608, 43.690769],
						[121.84595, 43.699034],
						[121.83043, 43.70764],
						[121.814954, 43.712132],
						[121.804577, 43.719845],
						[121.813657, 43.725809],
						[121.805785, 43.741814],
						[121.773626, 43.759973],
						[121.785613, 43.773846],
						[121.797645, 43.771585],
						[121.798808, 43.775113],
						[121.813433, 43.775489],
						[121.808379, 43.784256],
						[121.808782, 43.793262],
						[121.804667, 43.800759],
						[121.700497, 43.82725],
						[121.695398, 43.82944],
						[121.687526, 43.846238],
						[121.68842, 43.854652],
						[121.669858, 43.869905],
						[121.668114, 43.880265],
						[121.684484, 43.894178],
						[121.678044, 43.908668],
						[121.666772, 43.90983],
						[121.65975, 43.918474],
						[121.644632, 43.929782],
						[121.634926, 43.928518],
						[121.604691, 43.950377],
						[121.609476, 43.95304],
						[121.597176, 43.957445],
						[121.589528, 43.96697],
						[121.585816, 43.963317],
						[121.579285, 43.968643],
						[121.583713, 43.97919],
						[121.571682, 43.978474],
						[121.560232, 43.984071],
						[121.560634, 44.000757],
						[121.531919, 44.03357],
						[121.469524, 44.08354],
						[121.425557, 44.108781],
						[121.402881, 44.108134],
						[121.394651, 44.137313],
						[121.381546, 44.142045],
						[121.34138, 44.127849],
						[121.291107, 44.129313],
						[121.268028, 44.141466],
						[121.266775, 44.138879],
						[121.241817, 44.133875],
						[121.239805, 44.139117],
						[121.227013, 44.131356],
						[121.202368, 44.127237],
						[121.206483, 44.104217],
						[121.181122, 44.081802],
						[121.167928, 44.063298],
						[121.159429, 44.066025],
						[121.148069, 44.058458],
						[121.123648, 44.063639],
						[121.106785, 44.057776],
						[121.088715, 44.048504],
						[121.083706, 44.05072],
						[121.078652, 44.043493],
						[121.062282, 44.04455],
						[121.038665, 44.036026],
						[121.059195, 44.022282],
						[121.086121, 44.025829],
						[121.085584, 44.013414],
						[121.090683, 43.97646],
						[121.099808, 43.957923],
						[121.112555, 43.944264],
						[121.133532, 43.917654],
						[121.104817, 43.911402],
						[121.11336, 43.878589],
						[121.135858, 43.853421],
						[121.14297, 43.851301],
						[121.139034, 43.844836],
						[121.098555, 43.839704],
						[121.077936, 43.842749],
						[121.021937, 43.842954],
						[120.966744, 43.857115],
						[120.905423, 43.866212],
						[120.870446, 43.862142],
						[120.832875, 43.85219],
						[120.797987, 43.849693]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": 150524,
			"name": "库伦旗",
			"center": [121.774886, 42.734692],
			"centroid": [121.561146, 42.801414],
			"childrenNum": 0,
			"level": "district",
			"parent": {
				"adcode": 150500
			},
			"subFeatureIndex": 4,
			"acroutes": [100000, 150000, 150500]
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[121.214042, 42.361793],
						[121.219498, 42.372166],
						[121.243651, 42.373252],
						[121.263913, 42.379314],
						[121.284756, 42.387792],
						[121.299068, 42.398897],
						[121.306806, 42.413431],
						[121.30703, 42.423375],
						[121.314633, 42.428277],
						[121.30448, 42.435594],
						[121.311368, 42.440354],
						[121.327157, 42.443504],
						[121.362984, 42.460828],
						[121.372332, 42.454564],
						[121.385124, 42.452044],
						[121.387092, 42.474928],
						[121.411737, 42.475872],
						[121.417059, 42.478391],
						[121.415807, 42.486192],
						[121.423142, 42.485387],
						[121.433832, 42.475418],
						[121.45132, 42.476572],
						[121.465275, 42.48119],
						[121.479409, 42.496369],
						[121.497032, 42.492277],
						[121.506335, 42.482449],
						[121.515102, 42.491718],
						[121.527178, 42.483533],
						[121.552404, 42.490599],
						[121.570116, 42.486926],
						[121.57848, 42.492103],
						[121.576512, 42.496684],
						[121.591004, 42.502384],
						[121.590602, 42.509098],
						[121.608179, 42.515741],
						[121.61055, 42.509168],
						[121.601962, 42.502],
						[121.605272, 42.493956],
						[121.627994, 42.476047],
						[121.638013, 42.48035],
						[121.64177, 42.468456],
						[121.656709, 42.443014],
						[121.665565, 42.437379],
						[121.674331, 42.440179],
						[121.690567, 42.437414],
						[121.71141, 42.443714],
						[121.725634, 42.457643],
						[121.747282, 42.484583],
						[121.775281, 42.494481],
						[121.782348, 42.494691],
						[121.792904, 42.507524],
						[121.802341, 42.514587],
						[121.806948, 42.508923],
						[121.803191, 42.500356],
						[121.817683, 42.504203],
						[121.823408, 42.525075],
						[121.832756, 42.533918],
						[121.840941, 42.531227],
						[121.844474, 42.522418],
						[121.854046, 42.528395],
						[121.856238, 42.539405],
						[121.869432, 42.527976],
						[121.870774, 42.548875],
						[121.890141, 42.556841],
						[121.905482, 42.570955],
						[121.905885, 42.584017],
						[121.895821, 42.594179],
						[121.903649, 42.59397],
						[121.910134, 42.585554],
						[121.917648, 42.590897],
						[121.911699, 42.600115],
						[121.921137, 42.606573],
						[121.90253, 42.620466],
						[121.918543, 42.627097],
						[121.917648, 42.630448],
						[121.902173, 42.630587],
						[121.908211, 42.639101],
						[121.91975, 42.635961],
						[121.916664, 42.645486],
						[121.920242, 42.652708],
						[121.916172, 42.657243],
						[121.929456, 42.667078],
						[121.939744, 42.663102],
						[121.941443, 42.66952],
						[121.935539, 42.68169],
						[121.938446, 42.687896],
						[121.959424, 42.686746],
						[121.962152, 42.699261],
						[121.968682, 42.700934],
						[121.979551, 42.696612],
						[121.981608, 42.690476],
						[121.988944, 42.695391],
						[121.990509, 42.703618],
						[121.999455, 42.705012],
						[122.021953, 42.6994],
						[122.026828, 42.706685],
						[122.047581, 42.710693],
						[122.050131, 42.719231],
						[122.061044, 42.723413],
						[122.073165, 42.719754],
						[122.072808, 42.710658],
						[122.091012, 42.714457],
						[122.096334, 42.703269],
						[122.109305, 42.701945],
						[122.121605, 42.696089],
						[122.133458, 42.696298],
						[122.139764, 42.690162],
						[122.162307, 42.685107],
						[122.162933, 42.68957],
						[122.172863, 42.686711],
						[122.196255, 42.690894],
						[122.195853, 42.679877],
						[122.203725, 42.683189],
						[122.206498, 42.706825],
						[122.209673, 42.711495],
						[122.203635, 42.73188],
						[122.206095, 42.732472],
						[122.174607, 42.751561],
						[122.137841, 42.777016],
						[122.13319, 42.786311],
						[122.122634, 42.778896],
						[122.057913, 42.778478],
						[122.043958, 42.796439],
						[122.029646, 42.794908],
						[122.023294, 42.807297],
						[122.026112, 42.825146],
						[122.018956, 42.847058],
						[122.029109, 42.853247],
						[122.012202, 42.855438],
						[122.008713, 42.862287],
						[121.989615, 42.881788],
						[121.969219, 42.884082],
						[121.927354, 42.881024],
						[121.916843, 42.900692],
						[121.887726, 42.904931],
						[121.884282, 42.918722],
						[121.872026, 42.9281],
						[121.862902, 42.931469],
						[121.852704, 42.940983],
						[121.8451, 42.954315],
						[121.831906, 42.95855],
						[121.818443, 42.99013],
						[121.818309, 43.00588],
						[121.821127, 43.014342],
						[121.807306, 43.035147],
						[121.806858, 43.048008],
						[121.78946, 43.072301],
						[121.781677, 43.092429],
						[121.781319, 43.101711],
						[121.76647, 43.113103],
						[121.761371, 43.12574],
						[121.770137, 43.141662],
						[121.77139, 43.151352],
						[121.76155, 43.173563],
						[121.761147, 43.192274],
						[121.735608, 43.207557],
						[121.703583, 43.216683],
						[121.696024, 43.226326],
						[121.680996, 43.239458],
						[121.669903, 43.244813],
						[121.673973, 43.25155],
						[121.658095, 43.256248],
						[121.618511, 43.282254],
						[121.606793, 43.297342],
						[121.590333, 43.305005],
						[121.592614, 43.290437],
						[121.583758, 43.275348],
						[121.575618, 43.270202],
						[121.575394, 43.261602],
						[121.568327, 43.256421],
						[121.569803, 43.247024],
						[121.561171, 43.239769],
						[121.563318, 43.232961],
						[121.558129, 43.22878],
						[121.559695, 43.221418],
						[121.570564, 43.201126],
						[121.569535, 43.188297],
						[121.552673, 43.173598],
						[121.546187, 43.170934],
						[121.531204, 43.172906],
						[121.499268, 43.183317],
						[121.481377, 43.19217],
						[121.444164, 43.195213],
						[121.437589, 43.190995],
						[121.443046, 43.164742],
						[121.41943, 43.12844],
						[121.41612, 43.117847],
						[121.408069, 43.106005],
						[121.391833, 43.101607],
						[121.392906, 43.09132],
						[121.372153, 43.075316],
						[121.327783, 43.080616],
						[121.313471, 43.079924],
						[121.298711, 43.087891],
						[121.297324, 43.092602],
						[121.280954, 43.096723],
						[121.252954, 43.085778],
						[121.229159, 43.090766],
						[121.214489, 43.103511],
						[121.195793, 43.101953],
						[121.194004, 43.090939],
						[121.214131, 43.058059],
						[121.208451, 43.042462],
						[121.173429, 43.037921],
						[121.160324, 43.037852],
						[121.15433, 43.029461],
						[121.154867, 43.020723],
						[121.161129, 43.012192],
						[121.158535, 42.984302],
						[121.158982, 42.965284],
						[121.172624, 42.962577],
						[121.180138, 42.955253],
						[121.202189, 42.942928],
						[121.222316, 42.922404],
						[121.220303, 42.898851],
						[121.189218, 42.874872],
						[121.179378, 42.846745],
						[121.177276, 42.832207],
						[121.189665, 42.8153],
						[121.190381, 42.792645],
						[121.186087, 42.788538],
						[121.185327, 42.772664],
						[121.188234, 42.762044],
						[121.178036, 42.757273],
						[121.156791, 42.742644],
						[121.156612, 42.729963],
						[121.161487, 42.728848],
						[121.16757, 42.700202],
						[121.16842, 42.673112],
						[121.18309, 42.666172],
						[121.197358, 42.64102],
						[121.205991, 42.646254],
						[121.196956, 42.63282],
						[121.196687, 42.624829],
						[121.190604, 42.622002],
						[121.187071, 42.631948],
						[121.181525, 42.628807],
						[121.182375, 42.60591],
						[121.175173, 42.603397],
						[121.182151, 42.590932],
						[121.181748, 42.579442],
						[121.165915, 42.580735],
						[121.157596, 42.574518],
						[121.166139, 42.557331],
						[121.150439, 42.543983],
						[121.150752, 42.531331],
						[121.143417, 42.527382],
						[121.145206, 42.521789],
						[121.134472, 42.519307],
						[121.13881, 42.512804],
						[121.137826, 42.499622],
						[121.163723, 42.488255],
						[121.169851, 42.48126],
						[121.179959, 42.481505],
						[121.173653, 42.471814],
						[121.187518, 42.467126],
						[121.198208, 42.454214],
						[121.181569, 42.444099],
						[121.186266, 42.439864],
						[121.204917, 42.440529],
						[121.197806, 42.429642],
						[121.189576, 42.424986],
						[121.190426, 42.419349],
						[121.181391, 42.407653],
						[121.199505, 42.404501],
						[121.197224, 42.396795],
						[121.20192, 42.384674],
						[121.210061, 42.375565],
						[121.214042, 42.361793]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": 150525,
			"name": "奈曼旗",
			"center": [120.662543, 42.84685],
			"centroid": [120.935823, 42.966933],
			"childrenNum": 0,
			"level": "district",
			"parent": {
				"adcode": 150500
			},
			"subFeatureIndex": 5,
			"acroutes": [100000, 150000, 150500]
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[121.214042, 42.361793],
						[121.210061, 42.375565],
						[121.20192, 42.384674],
						[121.197224, 42.396795],
						[121.199505, 42.404501],
						[121.181391, 42.407653],
						[121.190426, 42.419349],
						[121.189576, 42.424986],
						[121.197806, 42.429642],
						[121.204917, 42.440529],
						[121.186266, 42.439864],
						[121.181569, 42.444099],
						[121.198208, 42.454214],
						[121.187518, 42.467126],
						[121.173653, 42.471814],
						[121.179959, 42.481505],
						[121.169851, 42.48126],
						[121.163723, 42.488255],
						[121.137826, 42.499622],
						[121.13881, 42.512804],
						[121.134472, 42.519307],
						[121.145206, 42.521789],
						[121.143417, 42.527382],
						[121.150752, 42.531331],
						[121.150439, 42.543983],
						[121.166139, 42.557331],
						[121.157596, 42.574518],
						[121.165915, 42.580735],
						[121.181748, 42.579442],
						[121.182151, 42.590932],
						[121.175173, 42.603397],
						[121.182375, 42.60591],
						[121.181525, 42.628807],
						[121.187071, 42.631948],
						[121.190604, 42.622002],
						[121.196687, 42.624829],
						[121.196956, 42.63282],
						[121.205991, 42.646254],
						[121.197358, 42.64102],
						[121.18309, 42.666172],
						[121.16842, 42.673112],
						[121.16757, 42.700202],
						[121.161487, 42.728848],
						[121.156612, 42.729963],
						[121.156791, 42.742644],
						[121.178036, 42.757273],
						[121.188234, 42.762044],
						[121.185327, 42.772664],
						[121.186087, 42.788538],
						[121.190381, 42.792645],
						[121.189665, 42.8153],
						[121.177276, 42.832207],
						[121.179378, 42.846745],
						[121.189218, 42.874872],
						[121.220303, 42.898851],
						[121.222316, 42.922404],
						[121.202189, 42.942928],
						[121.180138, 42.955253],
						[121.172624, 42.962577],
						[121.158982, 42.965284],
						[121.158535, 42.984302],
						[121.161129, 43.012192],
						[121.154867, 43.020723],
						[121.15433, 43.029461],
						[121.160324, 43.037852],
						[121.173429, 43.037921],
						[121.208451, 43.042462],
						[121.214131, 43.058059],
						[121.194004, 43.090939],
						[121.195793, 43.101953],
						[121.214489, 43.103511],
						[121.229159, 43.090766],
						[121.252954, 43.085778],
						[121.280954, 43.096723],
						[121.297324, 43.092602],
						[121.298711, 43.087891],
						[121.313471, 43.079924],
						[121.327783, 43.080616],
						[121.372153, 43.075316],
						[121.392906, 43.09132],
						[121.391833, 43.101607],
						[121.408069, 43.106005],
						[121.41612, 43.117847],
						[121.41943, 43.12844],
						[121.443046, 43.164742],
						[121.437589, 43.190995],
						[121.444164, 43.195213],
						[121.481377, 43.19217],
						[121.499268, 43.183317],
						[121.531204, 43.172906],
						[121.546187, 43.170934],
						[121.552673, 43.173598],
						[121.569535, 43.188297],
						[121.570564, 43.201126],
						[121.559695, 43.221418],
						[121.558129, 43.22878],
						[121.563318, 43.232961],
						[121.561171, 43.239769],
						[121.569803, 43.247024],
						[121.568327, 43.256421],
						[121.575394, 43.261602],
						[121.575618, 43.270202],
						[121.583758, 43.275348],
						[121.592614, 43.290437],
						[121.590333, 43.305005],
						[121.603036, 43.302899],
						[121.605093, 43.30787],
						[121.595298, 43.309423],
						[121.594493, 43.314565],
						[121.604333, 43.311079],
						[121.593106, 43.318879],
						[121.579375, 43.317429],
						[121.56618, 43.322329],
						[121.560545, 43.334578],
						[121.566449, 43.339718],
						[121.559427, 43.354619],
						[121.548334, 43.365447],
						[121.533798, 43.370447],
						[121.528296, 43.367309],
						[121.525881, 43.402056],
						[121.510182, 43.410912],
						[121.499894, 43.424865],
						[121.498821, 43.436817],
						[121.469703, 43.443051],
						[121.439512, 43.454724],
						[121.423053, 43.455998],
						[121.41196, 43.467324],
						[121.417998, 43.470078],
						[121.41035, 43.496887],
						[121.406504, 43.501945],
						[121.399839, 43.526505],
						[121.38906, 43.529428],
						[121.372153, 43.538368],
						[121.348537, 43.538918],
						[121.329349, 43.535824],
						[121.314455, 43.538987],
						[121.301036, 43.532798],
						[121.280998, 43.529565],
						[121.267088, 43.529634],
						[121.244993, 43.534998],
						[121.230412, 43.535342],
						[121.219319, 43.531663],
						[121.194764, 43.537715],
						[121.174503, 43.536821],
						[121.154062, 43.532076],
						[121.141091, 43.525817],
						[121.12575, 43.522825],
						[121.11099, 43.528568],
						[121.098108, 43.528293],
						[121.090773, 43.523031],
						[121.04533, 43.532591],
						[121.030033, 43.519213],
						[121.006059, 43.512988],
						[120.988615, 43.511646],
						[120.97153, 43.514192],
						[120.960303, 43.513228],
						[120.943978, 43.506521],
						[120.928368, 43.495408],
						[120.895359, 43.47827],
						[120.880152, 43.475689],
						[120.846651, 43.477892],
						[120.837303, 43.472316],
						[120.799642, 43.457995],
						[120.790428, 43.457616],
						[120.786582, 43.448216],
						[120.790563, 43.441019],
						[120.78524, 43.436645],
						[120.777681, 43.430721],
						[120.772224, 43.413599],
						[120.745388, 43.40402],
						[120.714884, 43.383099],
						[120.711395, 43.369481],
						[120.69498, 43.36193],
						[120.685543, 43.347962],
						[120.675524, 43.344651],
						[120.667473, 43.327471],
						[120.648732, 43.318361],
						[120.641307, 43.305281],
						[120.630841, 43.299862],
						[120.631154, 43.293475],
						[120.609774, 43.286294],
						[120.596804, 43.274796],
						[120.587008, 43.275037],
						[120.585711, 43.267163],
						[120.574708, 43.257561],
						[120.571577, 43.245228],
						[120.557086, 43.233722],
						[120.554447, 43.227536],
						[120.526313, 43.218273],
						[120.519828, 43.206381],
						[120.498224, 43.19051],
						[120.478455, 43.189473],
						[120.47756, 43.177022],
						[120.469554, 43.175915],
						[120.462174, 43.152978],
						[120.460206, 43.134879],
						[120.441778, 43.128786],
						[120.43489, 43.121517],
						[120.409977, 43.113588],
						[120.409575, 43.100118],
						[120.419012, 43.103234],
						[120.42514, 43.098282],
						[120.410693, 43.093987],
						[120.40783, 43.088272],
						[120.39146, 43.099494],
						[120.381709, 43.099979],
						[120.373167, 43.092394],
						[120.372988, 43.086956],
						[120.359659, 43.076875],
						[120.35872, 43.069841],
						[120.348566, 43.058545],
						[120.354292, 43.045617],
						[120.362253, 43.042393],
						[120.358809, 43.029947],
						[120.366994, 43.021209],
						[120.386495, 42.985342],
						[120.428539, 42.986453],
						[120.403939, 42.939039],
						[120.420578, 42.914867],
						[120.408725, 42.907988],
						[120.396738, 42.885507],
						[120.42429, 42.867224],
						[120.415881, 42.862983],
						[120.415747, 42.856342],
						[120.423843, 42.860062],
						[120.427958, 42.835059],
						[120.446475, 42.820484],
						[120.457165, 42.774544],
						[120.45958, 42.75581],
						[120.480423, 42.727002],
						[120.489055, 42.7055],
						[120.498537, 42.690441],
						[120.511195, 42.652917],
						[120.529891, 42.628144],
						[120.537003, 42.612648],
						[120.544875, 42.605352],
						[120.54984, 42.593167],
						[120.554581, 42.601337],
						[120.565002, 42.598509],
						[120.564466, 42.5873],
						[120.551808, 42.584087],
						[120.564242, 42.580874],
						[120.565673, 42.562047],
						[120.562542, 42.558169],
						[120.571398, 42.544228],
						[120.569743, 42.540453],
						[120.588574, 42.537797],
						[120.599219, 42.53238],
						[120.602126, 42.524935],
						[120.595506, 42.513643],
						[120.620643, 42.486646],
						[120.653115, 42.465482],
						[120.653294, 42.454809],
						[120.665058, 42.442594],
						[120.685006, 42.439164],
						[120.68523, 42.433563],
						[120.713139, 42.418578],
						[120.768691, 42.394098],
						[120.767125, 42.366524],
						[120.79763, 42.358639],
						[120.801476, 42.354573],
						[120.791904, 42.34332],
						[120.795572, 42.336343],
						[120.841999, 42.309621],
						[120.853136, 42.292888],
						[120.861366, 42.286291],
						[120.847679, 42.278711],
						[120.859845, 42.270078],
						[120.874561, 42.268147],
						[120.88118, 42.271833],
						[120.905601, 42.267972],
						[120.912534, 42.272219],
						[120.930157, 42.274535],
						[120.936106, 42.279764],
						[120.958827, 42.273939],
						[120.9616, 42.266147],
						[120.97229, 42.261689],
						[120.991612, 42.264497],
						[121.012187, 42.258986],
						[121.006462, 42.254843],
						[121.028915, 42.242555],
						[121.038889, 42.248419],
						[121.031643, 42.25358],
						[121.048013, 42.260074],
						[121.068186, 42.252491],
						[121.086032, 42.277588],
						[121.103252, 42.283273],
						[121.107367, 42.279308],
						[121.121501, 42.280922],
						[121.123469, 42.287765],
						[121.133622, 42.30029],
						[121.148426, 42.301062],
						[121.153346, 42.310217],
						[121.15035, 42.314391],
						[121.169896, 42.322703],
						[121.184343, 42.332802],
						[121.187965, 42.342023],
						[121.185684, 42.349876],
						[121.214042, 42.361793]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": 150526,
			"name": "扎鲁特旗",
			"center": [120.905275, 44.555294],
			"centroid": [120.596058, 44.807432],
			"childrenNum": 0,
			"level": "district",
			"parent": {
				"adcode": 150500
			},
			"subFeatureIndex": 6,
			"acroutes": [100000, 150000, 150500]
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[120.797987, 43.849693],
						[120.832875, 43.85219],
						[120.870446, 43.862142],
						[120.905423, 43.866212],
						[120.966744, 43.857115],
						[121.021937, 43.842954],
						[121.077936, 43.842749],
						[121.098555, 43.839704],
						[121.139034, 43.844836],
						[121.14297, 43.851301],
						[121.135858, 43.853421],
						[121.11336, 43.878589],
						[121.104817, 43.911402],
						[121.133532, 43.917654],
						[121.112555, 43.944264],
						[121.099808, 43.957923],
						[121.090683, 43.97646],
						[121.085584, 44.013414],
						[121.086121, 44.025829],
						[121.059195, 44.022282],
						[121.038665, 44.036026],
						[121.062282, 44.04455],
						[121.078652, 44.043493],
						[121.083706, 44.05072],
						[121.088715, 44.048504],
						[121.106785, 44.057776],
						[121.123648, 44.063639],
						[121.148069, 44.058458],
						[121.159429, 44.066025],
						[121.167928, 44.063298],
						[121.181122, 44.081802],
						[121.206483, 44.104217],
						[121.202368, 44.127237],
						[121.224508, 44.135135],
						[121.222495, 44.142045],
						[121.196464, 44.16641],
						[121.204783, 44.175086],
						[121.183985, 44.182229],
						[121.167972, 44.213684],
						[121.169001, 44.244136],
						[121.165915, 44.268018],
						[121.195972, 44.277935],
						[121.208451, 44.292603],
						[121.226878, 44.287443],
						[121.287126, 44.298918],
						[121.336818, 44.319452],
						[121.336639, 44.331464],
						[121.349655, 44.333805],
						[121.370006, 44.344898],
						[121.395366, 44.368196],
						[121.421174, 44.388028],
						[121.427883, 44.395925],
						[121.416254, 44.401924],
						[121.430835, 44.414291],
						[121.508885, 44.351715],
						[121.514878, 44.356565],
						[121.53344, 44.346492],
						[121.525389, 44.341098],
						[121.53666, 44.327324],
						[121.579867, 44.293079],
						[121.626831, 44.281229],
						[121.652236, 44.282655],
						[121.707787, 44.283742],
						[121.720982, 44.288631],
						[121.748355, 44.294844],
						[121.763562, 44.305367],
						[121.81652, 44.321658],
						[121.828015, 44.324135],
						[121.842327, 44.321352],
						[121.85248, 44.327562],
						[121.865809, 44.32634],
						[121.873905, 44.332685],
						[121.882, 44.344626],
						[121.892422, 44.341913],
						[121.90253, 44.350766],
						[121.910268, 44.345678],
						[121.922747, 44.350019],
						[121.934376, 44.343507],
						[121.933884, 44.351444],
						[121.882627, 44.402093],
						[121.858429, 44.411987],
						[121.841567, 44.413309],
						[121.829491, 44.411479],
						[121.822558, 44.429569],
						[121.778457, 44.446604],
						[121.759939, 44.478255],
						[121.697724, 44.534678],
						[121.66798, 44.55175],
						[121.665162, 44.561855],
						[121.651252, 44.56324],
						[121.643111, 44.56912],
						[121.630588, 44.58679],
						[121.625668, 44.587128],
						[121.603975, 44.609283],
						[121.605183, 44.617724],
						[121.585413, 44.640036],
						[121.603394, 44.646921],
						[121.595969, 44.65927],
						[121.548424, 44.667704],
						[121.53429, 44.692189],
						[121.530175, 44.720438],
						[121.409277, 44.790933],
						[121.41035, 44.810487],
						[121.420369, 44.818226],
						[121.401673, 44.851357],
						[121.381098, 44.851693],
						[121.352115, 44.877982],
						[121.310832, 44.897775],
						[121.306985, 44.8967],
						[121.240252, 44.93405],
						[121.220885, 44.936233],
						[121.215115, 44.941974],
						[121.169672, 44.957818],
						[121.151692, 44.958053],
						[121.130491, 44.963222],
						[121.116715, 44.968826],
						[121.113002, 44.974363],
						[121.100121, 44.980671],
						[121.095872, 44.978456],
						[121.076102, 44.982281],
						[121.067962, 44.986407],
						[121.053112, 45.003581],
						[121.033343, 44.998382],
						[121.019164, 45.012132],
						[121.015899, 45.021084],
						[121.002794, 45.028895],
						[121.003018, 45.044716],
						[120.996845, 45.055405],
						[120.977657, 45.073261],
						[120.982801, 45.081333],
						[120.981191, 45.100989],
						[120.988079, 45.105341],
						[120.981235, 45.114949],
						[120.972022, 45.118764],
						[120.96169, 45.115685],
						[120.947019, 45.121308],
						[120.955204, 45.126629],
						[120.959453, 45.136433],
						[120.973006, 45.15714],
						[120.969696, 45.165067],
						[120.974974, 45.171019],
						[120.967817, 45.184259],
						[120.958022, 45.187569],
						[120.948182, 45.196694],
						[120.942994, 45.194054],
						[120.922419, 45.198131],
						[120.899474, 45.205985],
						[120.893749, 45.212836],
						[120.881717, 45.21768],
						[120.858459, 45.21601],
						[120.841552, 45.219251],
						[120.835156, 45.216143],
						[120.827999, 45.253219],
						[120.810556, 45.252918],
						[120.809348, 45.250314],
						[120.762161, 45.262334],
						[120.743375, 45.260197],
						[120.727273, 45.268309],
						[120.69829, 45.277488],
						[120.672035, 45.293707],
						[120.660451, 45.297744],
						[120.652623, 45.310187],
						[120.644438, 45.316558],
						[120.631601, 45.321127],
						[120.623864, 45.327864],
						[120.609327, 45.333899],
						[120.60718, 45.338534],
						[120.596535, 45.341201],
						[120.591078, 45.347601],
						[120.571622, 45.354668],
						[120.566434, 45.352501],
						[120.554178, 45.357834],
						[120.552389, 45.37363],
						[120.555923, 45.386556],
						[120.561066, 45.390554],
						[120.554447, 45.398214],
						[120.559456, 45.416862],
						[120.549348, 45.421257],
						[120.539239, 45.435237],
						[120.521661, 45.447018],
						[120.511195, 45.44389],
						[120.499387, 45.45517],
						[120.495541, 45.464352],
						[120.470851, 45.461891],
						[120.464589, 45.466714],
						[120.435159, 45.464419],
						[120.425811, 45.47197],
						[120.425676, 45.482413],
						[120.419996, 45.484109],
						[120.420309, 45.497542],
						[120.414226, 45.503493],
						[120.404342, 45.503094],
						[120.391326, 45.512567],
						[120.384796, 45.510972],
						[120.373524, 45.519015],
						[120.359346, 45.516523],
						[120.345928, 45.519381],
						[120.343781, 45.524864],
						[120.326158, 45.542606],
						[120.327768, 45.550412],
						[120.319851, 45.556092],
						[120.294625, 45.556955],
						[120.293283, 45.560376],
						[120.280447, 45.559811],
						[120.277271, 45.553202],
						[120.26931, 45.552173],
						[120.236077, 45.570537],
						[120.211074, 45.57907],
						[120.196538, 45.576414],
						[120.187995, 45.5878],
						[120.173101, 45.58926],
						[120.1659, 45.594903],
						[120.143044, 45.584613],
						[120.13884, 45.587667],
						[120.117773, 45.588829],
						[120.106144, 45.594206],
						[120.075193, 45.594936],
						[120.05587, 45.588962],
						[120.03789, 45.594969],
						[120.028497, 45.595168],
						[120.010338, 45.588364],
						[119.994952, 45.578704],
						[119.998709, 45.564925],
						[119.994281, 45.553202],
						[120.000498, 45.547456],
						[120.014095, 45.545064],
						[120.028139, 45.527456],
						[120.031762, 45.499537],
						[120.0166, 45.488332],
						[119.999603, 45.492688],
						[120.004434, 45.487368],
						[119.999514, 45.482147],
						[119.986901, 45.486237],
						[119.978, 45.485007],
						[119.962837, 45.498307],
						[119.957336, 45.496545],
						[119.942263, 45.503127],
						[119.92956, 45.494184],
						[119.914711, 45.49977],
						[119.906839, 45.505853],
						[119.913995, 45.511703],
						[119.920123, 45.526226],
						[119.915069, 45.544832],
						[119.91896, 45.55825],
						[119.914934, 45.560343],
						[119.889216, 45.559214],
						[119.876022, 45.548054],
						[119.864929, 45.552405],
						[119.862693, 45.558682],
						[119.818681, 45.573027],
						[119.797525, 45.568213],
						[119.7918, 45.564361],
						[119.784957, 45.569342],
						[119.768318, 45.571101],
						[119.768765, 45.574853],
						[119.756465, 45.579236],
						[119.729181, 45.57804],
						[119.711291, 45.573758],
						[119.708428, 45.541709],
						[119.719252, 45.526559],
						[119.721265, 45.516523],
						[119.735578, 45.507715],
						[119.739692, 45.489097],
						[119.744702, 45.482247],
						[119.725469, 45.477025],
						[119.684678, 45.476892],
						[119.684141, 45.451377],
						[119.67609, 45.44186],
						[119.660301, 45.431543],
						[119.647509, 45.427948],
						[119.633152, 45.405108],
						[119.589364, 45.394151],
						[119.504247, 45.394684],
						[119.365458, 45.396915],
						[119.313351, 45.38559],
						[119.26348, 45.321761],
						[119.248183, 45.303582],
						[119.302348, 45.260664],
						[119.322028, 45.246039],
						[119.337638, 45.252317],
						[119.492171, 45.223995],
						[119.507602, 45.19509],
						[119.551301, 45.168946],
						[119.575722, 45.155468],
						[119.591242, 45.14473],
						[119.594955, 45.136065],
						[119.621791, 45.121241],
						[119.636059, 45.120404],
						[119.637535, 45.115986],
						[119.656902, 45.102462],
						[119.677119, 45.063647],
						[119.682754, 45.04237],
						[119.697559, 45.028158],
						[119.701898, 45.015988],
						[119.712632, 45.004922],
						[119.708741, 44.988018],
						[119.716881, 44.984629],
						[119.717687, 44.969329],
						[119.731686, 44.956107],
						[119.740453, 44.941202],
						[119.74658, 44.938718],
						[119.756778, 44.922801],
						[119.778158, 44.91914],
						[119.801014, 44.911986],
						[119.805889, 44.907552],
						[119.819441, 44.906107],
						[119.832189, 44.898447],
						[119.845607, 44.896398],
						[119.858265, 44.88662],
						[119.85737, 44.882083],
						[119.871102, 44.870251],
						[119.892481, 44.865747],
						[119.93788, 44.83545],
						[119.943381, 44.827478],
						[119.968697, 44.805338],
						[119.97885, 44.801973],
						[119.984262, 44.793424],
						[120.000856, 44.78309],
						[120.02483, 44.773831],
						[120.043347, 44.756656],
						[120.045673, 44.748101],
						[120.053813, 44.744193],
						[120.063742, 44.730716],
						[120.076624, 44.726437],
						[120.077563, 44.714877],
						[120.082394, 44.708708],
						[120.083333, 44.687636],
						[120.0887, 44.686793],
						[120.094604, 44.673067],
						[120.1027, 44.662475],
						[120.113882, 44.65377],
						[120.127971, 44.646887],
						[120.156194, 44.636695],
						[120.180123, 44.635041],
						[120.175337, 44.625252],
						[120.159504, 44.60881],
						[120.156999, 44.598713],
						[120.166079, 44.585574],
						[120.182225, 44.588411],
						[120.189292, 44.580101],
						[120.207094, 44.570742],
						[120.210627, 44.555535],
						[120.214697, 44.551209],
						[120.232141, 44.549282],
						[120.24547, 44.540392],
						[120.248064, 44.530215],
						[120.255355, 44.524433],
						[120.278702, 44.521761],
						[120.286351, 44.517669],
						[120.289079, 44.506575],
						[120.29959, 44.504478],
						[120.301603, 44.49328],
						[120.293999, 44.488509],
						[120.312293, 44.476292],
						[120.318197, 44.464886],
						[120.306523, 44.457066],
						[120.32012, 44.450836],
						[120.316944, 44.446942],
						[120.325129, 44.44061],
						[120.312114, 44.418357],
						[120.339308, 44.390977],
						[120.37831, 44.386503],
						[120.37585, 44.381757],
						[120.380457, 44.351851],
						[120.388195, 44.338351],
						[120.400048, 44.332719],
						[120.415568, 44.320368],
						[120.409217, 44.311748],
						[120.429478, 44.286798],
						[120.454615, 44.26255],
						[120.481944, 44.262142],
						[120.497061, 44.249437],
						[120.54161, 44.256265],
						[120.560977, 44.261531],
						[120.574574, 44.235301],
						[120.59081, 44.235267],
						[120.611966, 44.231767],
						[120.61796, 44.234112],
						[120.645646, 44.235097],
						[120.65723, 44.22089],
						[120.653294, 44.185698],
						[120.688763, 44.182637],
						[120.695025, 44.14327],
						[120.705894, 44.129211],
						[120.745388, 44.113651],
						[120.736174, 44.09795],
						[120.735011, 44.088446],
						[120.708488, 44.081325],
						[120.694309, 44.062003],
						[120.692699, 44.03698],
						[120.724903, 43.997209],
						[120.765828, 43.94884],
						[120.774729, 43.935487],
						[120.775087, 43.903542],
						[120.780901, 43.896228],
						[120.79584, 43.885632],
						[120.797987, 43.849693]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": 150581,
			"name": "霍林郭勒市",
			"center": [119.657862, 45.532361],
			"centroid": [119.541133, 45.496581],
			"childrenNum": 0,
			"level": "district",
			"parent": {
				"adcode": 150500
			},
			"subFeatureIndex": 7,
			"acroutes": [100000, 150000, 150500]
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[119.313351, 45.38559],
						[119.365458, 45.396915],
						[119.504247, 45.394684],
						[119.589364, 45.394151],
						[119.633152, 45.405108],
						[119.647509, 45.427948],
						[119.660301, 45.431543],
						[119.67609, 45.44186],
						[119.684141, 45.451377],
						[119.684678, 45.476892],
						[119.725469, 45.477025],
						[119.744702, 45.482247],
						[119.739692, 45.489097],
						[119.735578, 45.507715],
						[119.721265, 45.516523],
						[119.719252, 45.526559],
						[119.708428, 45.541709],
						[119.711291, 45.573758],
						[119.729181, 45.57804],
						[119.756465, 45.579236],
						[119.655694, 45.62367],
						[119.565524, 45.655871],
						[119.545933, 45.636473],
						[119.559307, 45.616306],
						[119.496241, 45.550379],
						[119.396902, 45.512667],
						[119.304316, 45.468244],
						[119.318673, 45.444356],
						[119.307447, 45.437767],
						[119.313351, 45.38559]
					]
				]
			]
		}
	}]
}
export default mapJson